import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
};

const RemoveAdditionalChargeModal = ({ open, onClose, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            width={580}
            open={open}
            type="error"
            title="Remove Additional Charge"
            confirmButtonText="Remove"
            onCancel={onClose}
            onConfirm={onConfirm}
            content={
                <>
                    <Typography.Text>
                        The additional charge is default for the customer. Are you sure you want to remove it?
                    </Typography.Text>
                </>
            }
        />
    );
};

export default RemoveAdditionalChargeModal;
